import styled from "styled-components";
import { theme, ifProp } from "styled-tools";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const PhoneNumberStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 0;
  max-width: 650px;
  box-sizing: border-box;
`;

export const InputPhoneNumber = styled.input`
  cursor: pointer;
  box-sizing: border-box;
  font-size: 18px;
  border-radius: 12px;
  border: 1px solid ${theme("Silver_Sand")};
  color: ${theme("Dark_Silver")};
  padding: 15px 15px 15px 90px;
  width: 100%;
  margin: 8px 0;
`;

export const PhoneNumberContainer = styled.div<{ $error: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 650px;
  padding-block: 24px;

  input {
    border: 1px solid
      ${ifProp("$error", theme("Madder_Lake"), theme("Silver_Sand"))};
    border-left: 0;
    border-radius: 12px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 15px;

    &:focus-visible {
      outline-color: ${theme("Transparent")};
    }
  }

  .PhoneInput--disabled {
    & > div,
    input {
      background-color: ${theme("Silver_Sand")};
    }
  }

  .PhoneInputCountry {
    border: 1px solid
      ${ifProp("$error", theme("Madder_Lake"), theme("Silver_Sand"))};
    border-right: 0;
    border-radius: 12px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0 15px;
    margin-right: 0;
  }

  .PhoneInputCountryIcon--border {
    box-shadow: none;
    background: ${theme("Transparent")};
  }

  .PhoneInputCountryIconImg {
    border-radius: 3px;
  }
`;

export const Mask = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40px;

  p {
    margin: 0;
    margin-left: 5px;
    font-size: 18px;
  }
`;

export const LabelPhone = styled.label`
  color: ${theme("Dark_Silver")};
  display: flex;
  font-family: "Montserrat";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
  width: 100%;

  ${mediaQuery[Screen.mobile]} {
    font-size: 16px;
  }
`;

export const ErrorContainer = styled.div`
  color: ${theme("Madder_Lake")};
  display: flex;
  align-items: end;
  padding: 0 8px;
`;

export const ErrorMessage = styled.div`
  font-size: 16px;
  margin-left: 8px;
`;

export const Asterisk = styled.span`
  color: ${theme("Amaranth_Red")};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  font-family: "Montserrat";
  margin: 3px 3px 0 -7px;
`;

export const TextSection = styled.div`
  display: flex;
  flex-direction: row;
`;
